export default __webpack_public_path__ + "static/media/CSAP.88ab56ab.png";